import styled from '@emotion/styled'
import { useHistory } from 'react-router'
import { FcFlashOn } from 'react-icons/fc'
import { AiOutlineRight, AiOutlineShoppingCart } from 'react-icons/ai'
import {
  useGetProductCategoryList,
  useGetShopImageSlider,
  useFetchShopProductList,
} from '../../services/shop/shop-query'
import * as paths from '../../constant/path'
import { BORDER, GREEN, LIGHT_ORANGE, ORANGE, SHOP_PRIMARY, WHITE } from '../../constant/colors'
import Image from '../../components/common/Image'
import Text from '../../components/common/Text'
import Button from '../../components/common/Button'
import StarRating from '../../components/StarRating'
import { mobile, useScreen } from '../../utils/responsive-helper'
import PriceFormatter from '../../components/PriceFormatter'
import CoinFormatter from '../../components/CoinFormatter'
import Slider from '../../components/common/Slider'
import Input from '../../components/common/Input'
import { useGetUserCoin, useGetUserExpiredCoin } from '../../services/user/user-query'
import ImageSlider from '../../components/common/ImageSlider'
import dayjs from 'dayjs'
import { useCallback, useEffect, useState } from 'react'
import { useAddProductToCart } from '../../services/cart/cart-query'
import { ProductDetial } from '../../services/shop/shop-typed'

var customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)

const Layout = styled.div`
  overflow: none;
`

const Section = styled.div`
  margin: 16px 0;
`

const CoinDetailLayout = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(270deg, #ffb292 0%, #fe7339 43.58%, #fe7339 43.58%);
  border-radius: 8px;
  padding: 8px;
`

const FlashSaleSection = styled.div`
  background-color: ${LIGHT_ORANGE};
  margin: 16px 0;

  ${mobile} {
    margin: 8px 0;
  }
`

const HeaderStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const CategoryListLayout = styled.div`
  display: flex;
  flex-flow: row wrap;
  position: relative;
`

const CategoryCardStyle = styled.div`
  width: calc(20% - 8px);
  margin: 4px;
  padding: 8px;
  flex: 0 1 calc(20% - 8px);
  background-color: ${WHITE};
  border-radius: 4px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  text-align: center;

  ${mobile} {
    width: 112px;
    flex: 0 1 112px;
  }
`

const CategoryImageStyle = styled(Image)`
  margin: auto;
  display: block;
  height: 120px;
  max-width: 100%;
  margin-bottom: 8px;

  ${mobile} {
    height: 80px;
  }
`

const CategoryNameStyle = styled(Text)`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

const FlashSaleHeaderLayout = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px 8px;
`

const FlashSaleHeader = styled(Text)`
  display: flex;
  align-items: center;
  font-family: 'DBHelvethaicaX-Bold';
`

const FlashSaleTimeStyle = styled.div`
  display: flex;
  align-items: center;
  color: ${ORANGE};
`

const FlashSaleTimeBox = styled.div`
  background: ${ORANGE};
  margin: 0 4px;
  padding: 4px;
`

const ProductListLayout = styled.div`
  display: flex;
  flex-flow: row wrap;
  position: relative;
`

const ProductCardStyle = styled.div`
  margin: 4px;
  padding: 8px;
  flex: 0 1 calc(20% - 8px);
  width: calc(20% - 8px);
  background-color: ${WHITE};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${mobile} {
    width: calc(50% - 8px);
    margin: 4px;
    padding: 8px;
    flex: 0 1 calc(50% - 8px);
  }
`

const ProductImageStyle = styled(Image)`
  height: 180px;
  max-width: 100%;
  display: block;
  margin: auto;
  padding-bottom: 8px;
`

const ProductPriceStyle = styled.div`
  display: flex;
  align-item: center;
  justify-content: space-between;
`

const AddCartStyle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding-top: 4px;
`

const AddCartButton = styled(Button)`
  width: 32px;
  height: 32px;
  margin-left: 4px;
  border: none;
  z-index: 100;
`

const AddCartText = styled(Text)`
  display: flex;
  color: ${WHITE};
  padding: 8px;
`

const Shop = () => {
  const history = useHistory()
  const { isMobile } = useScreen()
  const { data: shopImageSlider } = useGetShopImageSlider()
  const { data: shopProductList, fetchNextPage } = useFetchShopProductList(isMobile ? 10 : 20)
  const { data: productCategoryList } = useGetProductCategoryList()
  const { data: userCoin = 0 } = useGetUserCoin()
  const { data: userExpiredCoin = '-' } = useGetUserExpiredCoin()
  const expireDate = '28/02/2022 00:00:00'
  let expireDateFormatter = dayjs(expireDate, 'DD/MM/YYYY HH:mm:ss')
  let nowFormatter = dayjs()
  const [seconds, setSeconds] = useState('00')
  const [minutes, setMinutes] = useState('00')
  const [hours, setHours] = useState('00')
  const [shopProduct, setShopProduct] = useState<ProductDetial[]>([])
  const { mutate: addProductToCart } = useAddProductToCart()
  const flashsaleData = undefined

  const setNewShopProductList = useCallback(() => {
    let newProduct: ProductDetial[] = []

    shopProductList?.pages?.map((data) =>
      data?.content?.map((content) => (newProduct = [...newProduct, content])),
    )

    return newProduct
  }, [shopProductList?.pages])

  useEffect(() => {
    if (shopProductList) {
      setShopProduct(setNewShopProductList())
    }
  }, [shopProductList, setNewShopProductList])

  useEffect(() => {
    if (shopProductList?.pages) {
      setShopProduct(setNewShopProductList())
    } else {
      fetchNextPage()
    }
  }, [shopProductList?.pages, setNewShopProductList, fetchNextPage])

  const startCountdown = useCallback(() => {
    let timer = expireDateFormatter.diff(nowFormatter, 'second')
    const myTimer = setInterval(() => {
      if (timer <= 0) {
        clearInterval(myTimer)
      }

      timer--
      const diifSeconds = Math.floor(timer % 60)
      const diffMinutes = Math.floor((timer / 60) % 60)
      const diffHours = Math.floor(timer / 60 / 60)
      setSeconds(diifSeconds.toString().padStart(2, '0'))
      setMinutes(diffMinutes.toString().padStart(2, '0'))
      setHours(diffHours.toString().padStart(2, '0'))
    }, 1000)
  }, [expireDateFormatter, nowFormatter])

  useEffect(() => {
    startCountdown()
  }, [startCountdown])

  const handleUserCoinNavigation = () => {
    history.push(paths.shopUserCoin())
  }

  const handleProductNavigation = () => {
    history.push(paths.products())
  }

  const handleNavigation = (productId: number) => {
    history.push(
      paths.productDetail({
        routeParam: {
          productId,
        },
        queryParam: {
          page: paths.shop(),
        },
      }),
    )
  }

  const handleAddCart = (productId: number, e: any) => {
    addProductToCart({
      productId,
      quantity: 1,
    })
    e.stopPropagation()
  }

  return (
    <Layout>
      {isMobile && (
        <>
          <Section>
            <Input
              inputStyle={{ borderRadius: 100, backgroundColor: BORDER }}
              placeholder="ค้นหาสินค้าที่ต้องการ"
            />
          </Section>
          <Section>
            <CoinDetailLayout onClick={handleUserCoinNavigation}>
              <CoinFormatter textColor={WHITE} textType="Bold" value={userCoin} />
              <Text size={12} color={WHITE}>
                {`หมดอายุ ณ วันที่ ${userExpiredCoin}`}
              </Text>
            </CoinDetailLayout>
          </Section>
        </>
      )}
      {shopImageSlider?.content && (
        <Section>
          <ImageSlider
            dotColor={GREEN}
            imageHeight={isMobile ? 150 : 400}
            images={shopImageSlider.content}
            status="Detail"
          />
        </Section>
      )}
      {productCategoryList?.content && (
        <Section>
          <HeaderStyled>
            <Text size={isMobile ? 24 : 32} type="SemiBold">
              หมวดหมู่สินค้า
            </Text>
            <Text
              size={isMobile ? 16 : 20}
              color={SHOP_PRIMARY}
              style={{ display: 'flex', alignItems: 'center' }}
              type="SemiBold"
              onClick={handleProductNavigation}
            >
              ดูเพิ่ม <AiOutlineRight />
            </Text>
          </HeaderStyled>
          {isMobile ? (
            <Slider>
              {productCategoryList.content?.map((category, index) => {
                return (
                  <CategoryCardStyle key={index}>
                    <CategoryImageStyle src={category.imagePath} />
                    <CategoryNameStyle>{category.name}</CategoryNameStyle>
                  </CategoryCardStyle>
                )
              })}
            </Slider>
          ) : (
            <CategoryListLayout>
              {productCategoryList.content?.map((category, index) => {
                if (index < 5) {
                  return (
                    <CategoryCardStyle key={index}>
                      <CategoryImageStyle src={category.imagePath} />
                      <CategoryNameStyle>{category.name}</CategoryNameStyle>
                    </CategoryCardStyle>
                  )
                }
              })}
            </CategoryListLayout>
          )}
        </Section>
      )}
      {flashsaleData && (
        <FlashSaleSection>
          <FlashSaleHeaderLayout>
            <FlashSaleHeader size={32}>
              <FcFlashOn /> Flash Sale
            </FlashSaleHeader>
            <FlashSaleTimeStyle>
              <FlashSaleTimeBox>
                <Text color={WHITE} type="SemiBold">
                  {hours}
                </Text>
              </FlashSaleTimeBox>
              {':'}
              <FlashSaleTimeBox>
                <Text color={WHITE} type="SemiBold">
                  {minutes}
                </Text>
              </FlashSaleTimeBox>
              {':'}
              <FlashSaleTimeBox>
                <Text color={WHITE} type="SemiBold">
                  {seconds}
                </Text>
              </FlashSaleTimeBox>
            </FlashSaleTimeStyle>
          </FlashSaleHeaderLayout>
        </FlashSaleSection>
      )}
      {shopProduct && (
        <Section>
          <HeaderStyled>
            <Text size={isMobile ? 24 : 32} type="SemiBold">
              สินค้าทั้งหมด
            </Text>
            <Text
              size={isMobile ? 16 : 20}
              color={SHOP_PRIMARY}
              style={{ display: 'flex', alignItems: 'center' }}
              type="SemiBold"
              onClick={handleProductNavigation}
            >
              ดูเพิ่ม <AiOutlineRight />
            </Text>
          </HeaderStyled>
          <ProductListLayout>
            {shopProduct.map((product, index) => {
              return (
                <ProductCardStyle key={index} onClick={() => handleNavigation(product.id)}>
                  <div>
                    <ProductImageStyle src={product.thumbnailImage} />
                    <ProductPriceStyle>
                      <div>
                        {product?.normalCoin !== 0 && (
                          <PriceFormatter
                            fontSize={14}
                            priceType="additional"
                            value={product.normalCoin}
                          />
                        )}
                        <PriceFormatter
                          fontSize={isMobile ? 24 : 28}
                          lineHeight={isMobile ? 28 : 32}
                          priceType="display"
                          value={product?.specialCoin}
                        />
                      </div>
                      <CoinFormatter textSize={isMobile ? 14 : 18} value={product?.specialCoin} />
                    </ProductPriceStyle>
                    <Text size={18}>{product.name}</Text>
                  </div>
                  <AddCartStyle>
                    <StarRating rating={product?.rating} />
                    <AddCartButton onClick={(e) => handleAddCart(product.id, e)}>
                      <AddCartText>
                        <AiOutlineShoppingCart />
                      </AddCartText>
                    </AddCartButton>
                  </AddCartStyle>
                </ProductCardStyle>
              )
            })}
          </ProductListLayout>
        </Section>
      )}
    </Layout>
  )
}

export default Shop
